import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 7000 } // Default timeout of 7 seconds
  }

  connect() {
    this.timeoutId = setTimeout(() => this.close(), this.timeoutValue)
  }

  close() {
    this.element.classList.add("opacity-0", "-translate-y-4")

    // Remove the element after the transition finishes (300ms)
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  disconnect() {
    clearTimeout(this.timeoutId)
  }
}
